import React from "react";
import { useLoaderData } from "react-router-dom";
import { ImCheckboxChecked } from "react-icons/im";
const ProjectDetails = () => {
  const detailProject = useLoaderData();
  const {
    project_name,
    image_url1,
    image_url2,
    image_url3,
    image_url4,
    repo,
    details,
    livesite,
    sourceCode,
    date,
  } = detailProject;
  console.log(project_name);

  return (
    <div
      className="container m-auto my-16 "
      style={{ minHeight: "calc(100vh - 6.5rem)" }}
    >
      <div className=" w-full grid grid-cols-1 lg:grid-cols-2">
        <div className="w-full">
          <div className="carousel w-full">
            <div id="slide1" className="carousel-item relative w-full">
              <img src={image_url1} className="w-full" />
              <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                <a href="#slide4" className="btn btn-circle">
                  ❮
                </a>
                <a href="#slide2" className="btn btn-circle">
                  ❯
                </a>
              </div>
            </div>
            <div id="slide2" className="carousel-item relative w-full">
              <img src={image_url2} className="w-full" />
              <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                <a href="#slide1" className="btn btn-circle">
                  ❮
                </a>
                <a href="#slide3" className="btn btn-circle">
                  ❯
                </a>
              </div>
            </div>
            <div id="slide3" className="carousel-item relative w-full">
              <img src={image_url3} className="w-full" />
              <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                <a href="#slide2" className="btn btn-circle">
                  ❮
                </a>
                <a href="#slide4" className="btn btn-circle">
                  ❯
                </a>
              </div>
            </div>
            <div id="slide4" className="carousel-item relative w-full">
              <img src={image_url4} className="w-full" />
              <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                <a href="#slide3" className="btn btn-circle">
                  ❮
                </a>
                <a href="#slide1" className="btn btn-circle">
                  ❯
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full mt-12 ">
          <div className="flex justify-evenly items-center">
            <h2 className="text-3xl font-bold ">{project_name}</h2>

            <span className=" font-bold ">{date}</span>
          </div>
          <p className="ml-16 mt-5">{details}</p>
          <div className="flex justify-start items-start ml-16 mt-5">
            <button className="bg-pink-600 p-3 rounded font-semibold mr-6">
              <a href={livesite} target="_blank" rel="noreferrer">
                LIVE SITE
              </a>
            </button>
            <button className="bg-pink-600 p-3 rounded font-semibold mr-6">
              <a href={sourceCode} target="_blank" rel="noreferrer">
                SOURCE CODE
              </a>
            </button>
          </div>
          <div className="ml-16 mt-5">
            <h1 className="text-xl font-bold my-5">FEATURES</h1>
            <ul>
              <li className="flex my-3 text-xl font-bold">
                <ImCheckboxChecked className="text-2xl bg-green-600"></ImCheckboxChecked>
                <h1 className="ml-3">CRUD Operation</h1>
              </li>
              <li className="flex my-3 text-xl font-bold">
                <ImCheckboxChecked className="text-2xl bg-green-600"></ImCheckboxChecked>
                <h1 className="ml-3">CRUD Operation</h1>
              </li>
              <li className="flex my-3 text-xl font-bold">
                <ImCheckboxChecked className="text-2xl bg-green-600"></ImCheckboxChecked>
                <h1 className="ml-3">NodeJS authentication with JWT</h1>
              </li>
              <li className="flex my-3 text-xl font-bold">
                <ImCheckboxChecked className="text-2xl bg-green-600"></ImCheckboxChecked>
                <h1 className="ml-3">User and Admin Dashboard</h1>
              </li>
              <li className="flex my-3 text-xl font-bold">
                <ImCheckboxChecked className="text-2xl bg-green-600"></ImCheckboxChecked>
                <h1 className="ml-3">Stripe Payment Geteway</h1>
              </li>
            </ul>
          </div>
          <div className="ml-16 mt-5">
            <h1 className="text-xl font-bold">TECHNOLOGIES</h1>
            <kbd className="kbd kbd-lg mr-3 mt-3 rounded">REACT JS</kbd>
            <kbd className="kbd kbd-lg mr-3 mt-3 rounded">REACT ROUTER DOM</kbd>
            <kbd className="kbd kbd-lg mr-3 mt-3 rounded">TWILDIND CSS</kbd>
            <kbd className="kbd kbd-lg mr-3 mt-3 rounded">NODE JS</kbd>
            <kbd className="kbd kbd-lg mr-3 mt-3 rounded">EXPRESS JS</kbd>
            <kbd className="kbd kbd-lg mr-3 mt-3 rounded">MONGODB</kbd>
            <kbd className="kbd kbd-lg mr-3 mt-3 rounded">JSON WEB TOKEN</kbd>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
